import React from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  if (bonus.cover) {
    return <img src={bonus.cover} alt={`${bonus.title} cover`} width={1024} height={1024} loading="lazy" className="aspect-[5/4] w-full border-b border-plum-line object-cover object-center" data-id="element-22" data-mp="pj6cm4pkakr0" />;
  }
  return <div aria-hidden="true" className="relative flex h-[230px] items-center justify-center border-b border-plum-line bg-cream sm:h-[265px]" data-id="element-23" data-mp="1u5b71f5c9v8">
      <div className="relative w-[62%] max-w-[260px] aspect-[4/3] overflow-hidden rounded-lg bg-white shadow-cover ring-1 ring-black/5" data-id="element-24" data-mp="5tnll39cd2jt">
        <div className="px-[8%] pt-[8%]" data-id="element-25" data-mp="3szwoh07trs0m">
          <span className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-coral-deep" data-id="element-26" data-mp="3t0yb81y7e2y6">
            Bonus {bonus.number}
          </span>
          <span className="mt-2 block font-display text-[15px] font-bold leading-tight text-plum sm:text-base" data-id="element-27" data-mp="1r9l7vhbvw348">
            {bonus.title}
          </span>
        </div>
        <span className="absolute left-[8%] bottom-[22%] flex gap-1" data-id="element-28" data-mp="3dfd2hjen40sv">
          <span className="h-1.5 w-1.5 rounded-full bg-sage" data-id="element-29" data-mp="3df3axrdy5ll2" />
          <span className="h-1.5 w-1.5 rounded-full bg-smoke" data-id="element-30" data-mp="3r700bno8dhdr" />
          <span className="h-1.5 w-1.5 rounded-full bg-lilac" data-id="element-31" data-mp="3n54ymi2e11zg" />
        </span>
        <span className="absolute bottom-[9%] left-[8%] font-display text-[10px] font-semibold text-ink-soft" data-id="element-32" data-mp="3n79dtw5qlnf1">
          Dance Class Ready
        </span>
        <span className={`absolute inset-x-0 bottom-0 h-[6%] ${bonus.accent}`} data-id="element-33" data-mp="2uh97rtzi24al" />
      </div>
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-plum" data-id="element-34" data-mp="38e5vhmkbn5n9">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-35" data-mp="33fm6teecffr7">
        <div className="text-center" data-id="element-36" data-mp="npi2m9269qr2">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-37" data-mp="noghfbrfznvm">
            Also included at no extra cost
          </p>
          <h2 id="bonuses-heading" className="mt-3 font-display font-bold text-white text-3xl sm:text-5xl" data-id="element-38" data-mp="3cj6icglspwqf">
            Five instant-use <span className="text-gold" data-id="element-39" data-mp="3hg6enzsufl4c">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-40" data-mp="3lknvpr7tjkbf">
            The volumes give you the season. These five get you teaching from
            it this week.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-41" data-mp="2ttggj9jm8ap0">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-3xl border border-plum-line bg-plum-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-42" data-mp="2xv1uyzbssx1b" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-43" data-mp="2a460fufyjnqd" />
              <div className="px-5 pb-6 pt-4" data-id="element-44" data-mp="2f391z4wqbbtl">
                <div className="flex flex-wrap items-center gap-2" data-id="element-45" data-mp="2f1xy753aa42h">
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-46" data-mp="27k9jd1h3doba">
                    Bonus {bonus.number}
                  </span>
                  <span className="rounded-full bg-gold px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-gold-ink" data-id="element-47" data-mp="1xltxbcwx958n">
                    Free today
                  </span>
                </div>
                <h3 className="mt-2.5 font-display text-xl font-bold leading-snug text-white" data-id="element-48" data-mp="1olnk7s54y7a0">
                  {bonus.title}
                </h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-49" data-mp="1jt47exe9vg69">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}